import { createEntitySource } from 'serviceWorker/channelServers/entitySource';
import * as dbCompanies from 'serviceWorker/db/companies/companies';
import * as dbCompaniesService from 'serviceWorker/db/companies/companiesService';
import { companyEntityToModel } from 'serviceWorker/repository/company/mapping';
import { getCurrentUsers } from 'serviceWorker/services/users/getUsers';
import { companyContract } from 'shared/domain/company/companyContract';
import { companiesSync } from './index';

/** Active companies of IndexedDB, with the users downloaded so far (a missing users download must not block them). */
export const companySource = createEntitySource({
  service: dbCompaniesService,
  contract: companyContract,
  ...companiesSync,
  readAll: async () => {
    const [companies, users] = await Promise.all([dbCompanies.get(), getCurrentUsers()]);
    return companies.map((company) => companyEntityToModel(company, users));
  },
});
